export const footerLinks = {
    'tj-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://tj.wingie.com/flights/to-dushanbe/',
                    title: 'Душанбе',
                },
                {
                    href: 'https://tj.wingie.com/flights/to-khujand/',
                    title: 'Худжанд',
                },
                {
                    href: 'https://tj.wingie.com/flights/to-kulob/',
                    title: 'Куляб',
                },
                {
                    href: 'https://tj.wingie.com/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://tj.wingie.com/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://tj.wingie.com/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://tj.wingie.com/flights/ru-russia/',
                    title: 'Россия',
                },
                {
                    href: 'https://tj.wingie.com/flights/tr-turkey/',
                    title: 'Турция',
                },
                {
                    href: 'https://tj.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'ОАЭ',
                },
                {
                    href: 'https://tj.wingie.com/flights/kz-kazakhstan/',
                    title: 'Казахстан',
                },
                {
                    href: 'https://tj.wingie.com/flights/uz-uzbekistan/',
                    title: 'Узбекистан',
                },
                {
                    href: 'https://tj.wingie.com/flights/cn-china/',
                    title: 'Китай',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://tj.wingie.com/flights/airlines/somon-air/',
                    title: 'Somon Air',
                },
                {
                    href: 'https://tj.wingie.com/flights/airlines/tajik-air/',
                    title: 'Tajik Air',
                },
                {
                    href: 'https://tj.wingie.com/flights/airlines/ural-airlines/',
                    title: 'Ural Airlines',
                },
                {
                    href: 'https://tj.wingie.com/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://tj.wingie.com/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://tj.wingie.com/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'tj-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://tj.wingie.com/en/flights/to-dushanbe/',
                    title: 'Dushanbe',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/to-khujand/',
                    title: 'Khujand',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/to-kulob/',
                    title: 'Kulob',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/to-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://tj.wingie.com/en/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/tr-turkey/',
                    title: 'Turkey',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'UAE',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/kz-kazakhstan/',
                    title: 'Kazakhstan',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/uz-uzbekistan/',
                    title: 'Uzbekistan',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/cn-china/',
                    title: 'China',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/somon-air/',
                    title: 'Somon Air',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/tajik-air/',
                    title: 'Tajik Air',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/ural-airlines/',
                    title: 'Ural Airlines',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://tj.wingie.com/en/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'tj-es': [
        {
            title: 'Destinos principales',
            items: [
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-dushanbe/',
                    title: 'Dushanbe',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-khujand/',
                    title: 'Khujand',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-kulob/',
                    title: 'Kulob',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-moscu/',
                    title: 'Moscú',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubái',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://tj.wingie.com/es/vuelos/ru-rusia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/tr-turquia/',
                    title: 'Turquía',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
                    title: 'Emiratos Árabes Unidos',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/kz-kazajistan/',
                    title: 'Kazajistán',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/uz-uzbekistan/',
                    title: 'Uzbekistán',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/cn-china/',
                    title: 'China',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://tj.wingie.com/es/vuelos/companias-aereas/somon-air/',
                    title: 'Somon Air',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/companies-airlines/tajik-air/',
                    title: 'Tajik Air',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/companies-airlines/ural-airlines/',
                    title: 'Ural Airlines',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/companies-airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/companies-airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://tj.wingie.com/es/vuelos/companies-airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'tj-de': [
        {
            title: 'Top-Reiseziele',
            items: [
                {
                    href: 'https://tj.wingie.com/de/flug/nach-duschanbe/',
                    title: 'Duschanbe',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/nach-chudschand/',
                    title: 'Chudschand',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/nach-kulob/',
                    title: 'Kulob',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/nach-moskau/',
                    title: 'Moskau',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://tj.wingie.com/de/flug/ru-russland/',
                    title: 'Russland',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/tr-turkei/',
                    title: 'Türkei',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/ae-vereinigte-arabische-emirate/',
                    title: 'Vereinigte Arabische Emirate',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/kz-kasachstan/',
                    title: 'Kasachstan',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/uz-usbekistan/',
                    title: 'Usbekistan',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/cn-china/',
                    title: 'China',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/somon-air/',
                    title: 'Somon Air',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/tajik-air/',
                    title: 'Tajik Air',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/ural-airlines/',
                    title: 'Ural Airlines',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://tj.wingie.com/de/flug/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'tj-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://tj.wingie.com/ar/flights/to-dushanbe/',
                    title: 'دوشانبي',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/to-khujand/',
                    title: 'خجند',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/to-kulob/',
                    title: 'كولوب',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/to-moscow/',
                    title: 'موسكو',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/to-istanbul/',
                    title: 'إسطنبول',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/to-dubai/',
                    title: 'دبي',
                },
            ],
        },
        {
            title: 'الدول الشعبية',
            items: [
                {
                    href: 'https://tj.wingie.com/ar/flights/ru-russia/',
                    title: 'روسيا',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/kz-kazakhstan/',
                    title: 'كازاخستان',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/uz-uzbekistan/',
                    title: 'أوزبكستان',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/cn-china/',
                    title: 'الصين',
                },
            ],
        },
        {
            title: 'شركات الطيران الشعبية',
            items: [
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/somon-air/',
                    title: 'سومون إير',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/tajik-air/',
                    title: 'طاجيك إير',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/ural-airlines/',
                    title: 'أورال إيرلاينز',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/s7-airlines/',
                    title: 'إس 7 إيرلاينز',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://tj.wingie.com/ar/flights/airlines/fly-dubai/',
                    title: 'فلاي دبي',
                },
            ],
        },
    ],
    'tj-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { href: 'https://tj.wingie.com/it/flights/to-dushanbe/', title: 'Dushanbe' },
                { href: 'https://tj.wingie.com/it/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/it/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/it/flights/to-mosca/', title: 'Mosca' },
                { href: 'https://tj.wingie.com/it/flights/to-istanbul/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/it/flights/to-dubai/', title: 'Dubai' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { href: 'https://tj.wingie.com/it/flights/ru-russia/', title: 'Russia' },
                { href: 'https://tj.wingie.com/it/flights/tr-turchia/', title: 'Turchia' },
                { href: 'https://tj.wingie.com/it/flights/ae-emirati-arabi-uniti/', title: 'Emirati Arabi Uniti' },
                { href: 'https://tj.wingie.com/it/flights/kz-kazakhstan/', title: 'Kazakistan' },
                { href: 'https://tj.wingie.com/it/flights/uz-uzbekistan/', title: 'Uzbekistan' },
                { href: 'https://tj.wingie.com/it/flights/cn-cina/', title: 'Cina' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { href: 'https://tj.wingie.com/it/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/it/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/it/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/it/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/it/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/it/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-fr': [
        {
            title: 'Principales destinations',
            items: [
                { href: 'https://tj.wingie.com/fr/flights/to-douchanbé/', title: 'Douchanbé' },
                { href: 'https://tj.wingie.com/fr/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/fr/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/fr/flights/to-moscou/', title: 'Moscou' },
                { href: 'https://tj.wingie.com/fr/flights/to-istanbul/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/fr/flights/to-dubai/', title: 'Dubaï' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { href: 'https://tj.wingie.com/fr/flights/ru-russie/', title: 'Russie' },
                { href: 'https://tj.wingie.com/fr/flights/tr-turquie/', title: 'Turquie' },
                { href: 'https://tj.wingie.com/fr/flights/ae-emirats-arabes-unis/', title: 'Émirats arabes unis' },
                { href: 'https://tj.wingie.com/fr/flights/kz-kazakhstan/', title: 'Kazakhstan' },
                { href: 'https://tj.wingie.com/fr/flights/uz-ouzbekistan/', title: 'Ouzbékistan' },
                { href: 'https://tj.wingie.com/fr/flights/cn-chine/', title: 'Chine' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { href: 'https://tj.wingie.com/fr/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/fr/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/fr/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/fr/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/fr/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/fr/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-pt': [
        {
            title: 'Principais destinos',
            items: [
                { href: 'https://tj.wingie.com/pt/flights/to-dushanbe/', title: 'Dushanbe' },
                { href: 'https://tj.wingie.com/pt/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/pt/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/pt/flights/to-moscou/', title: 'Moscou' },
                { href: 'https://tj.wingie.com/pt/flights/to-istanbul/', title: 'Istambul' },
                { href: 'https://tj.wingie.com/pt/flights/to-dubai/', title: 'Dubai' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { href: 'https://tj.wingie.com/pt/flights/ru-russia/', title: 'Rússia' },
                { href: 'https://tj.wingie.com/pt/flights/tr-turquia/', title: 'Turquia' },
                { href: 'https://tj.wingie.com/pt/flights/ae-emirados-arabes-unidos/', title: 'Emirados Árabes Unidos' },
                { href: 'https://tj.wingie.com/pt/flights/kz-kazakhstan/', title: 'Cazaquistão' },
                { href: 'https://tj.wingie.com/pt/flights/uz-uzbekistan/', title: 'Uzbequistão' },
                { href: 'https://tj.wingie.com/pt/flights/cn-china/', title: 'China' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { href: 'https://tj.wingie.com/pt/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/pt/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/pt/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/pt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/pt/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/pt/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-ro': [
        {
            title: 'Top destinații',
            items: [
                { href: 'https://tj.wingie.com/ro/flights/to-dushanbe/', title: 'Dushanbe' },
                { href: 'https://tj.wingie.com/ro/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/ro/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/ro/flights/to-moscova/', title: 'Moscova' },
                { href: 'https://tj.wingie.com/ro/flights/to-istanbul/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/ro/flights/to-dubai/', title: 'Dubai' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { href: 'https://tj.wingie.com/ro/flights/ru-rusia/', title: 'Rusia' },
                { href: 'https://tj.wingie.com/ro/flights/tr-turcia/', title: 'Turcia' },
                { href: 'https://tj.wingie.com/ro/flights/ae-emiratele-arabe-unite/', title: 'Emiratele Arabe Unite' },
                { href: 'https://tj.wingie.com/ro/flights/kz-kazakhstan/', title: 'Kazahstan' },
                { href: 'https://tj.wingie.com/ro/flights/uz-uzbekistan/', title: 'Uzbekistan' },
                { href: 'https://tj.wingie.com/ro/flights/cn-china/', title: 'China' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { href: 'https://tj.wingie.com/ro/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/ro/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/ro/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/ro/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/ro/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/ro/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { href: 'https://tj.wingie.com/pl/flights/to-duszanbe/', title: 'Duszanbe' },
                { href: 'https://tj.wingie.com/pl/flights/to-chudżend/', title: 'Chudżend' },
                { href: 'https://tj.wingie.com/pl/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/pl/flights/to-moskwy/', title: 'Moskwa' },
                { href: 'https://tj.wingie.com/pl/flights/to-stambulu/', title: 'Stambuł' },
                { href: 'https://tj.wingie.com/pl/flights/to-dubaju/', title: 'Dubaj' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { href: 'https://tj.wingie.com/pl/flights/ru-rosja/', title: 'Rosja' },
                { href: 'https://tj.wingie.com/pl/flights/tr-turcja/', title: 'Turcja' },
                { href: 'https://tj.wingie.com/pl/flights/ae-zjednoczone-emiraty-arabskie/', title: 'Zjednoczone Emiraty Arabskie' },
                { href: 'https://tj.wingie.com/pl/flights/kz-kazachstan/', title: 'Kazachstan' },
                { href: 'https://tj.wingie.com/pl/flights/uz-uzbekistan/', title: 'Uzbekistan' },
                { href: 'https://tj.wingie.com/pl/flights/cn-chiny/', title: 'Chiny' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { href: 'https://tj.wingie.com/pl/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/pl/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/pl/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/pl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/pl/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/pl/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { href: 'https://tj.wingie.com/lt/flights/to-dušanbė/', title: 'Dušanbė' },
                { href: 'https://tj.wingie.com/lt/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/lt/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/lt/flights/to-maskva/', title: 'Maskva' },
                { href: 'https://tj.wingie.com/lt/flights/to-stambula/', title: 'Stambulas' },
                { href: 'https://tj.wingie.com/lt/flights/to-dubajus/', title: 'Dubajus' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { href: 'https://tj.wingie.com/lt/flights/ru-rusija/', title: 'Rusija' },
                { href: 'https://tj.wingie.com/lt/flights/tr-turkija/', title: 'Turkija' },
                { href: 'https://tj.wingie.com/lt/flights/ae-jungtiniai-arabu-emyratai/', title: 'Jungtiniai Arabų Emyratai' },
                { href: 'https://tj.wingie.com/lt/flights/kz-kazachstanas/', title: 'Kazachstanas' },
                { href: 'https://tj.wingie.com/lt/flights/uz-uzbekistanas/', title: 'Uzbekistanas' },
                { href: 'https://tj.wingie.com/lt/flights/cn-kinija/', title: 'Kinija' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { href: 'https://tj.wingie.com/lt/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/lt/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/lt/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/lt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/lt/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/lt/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-uz': [
        {
            title: "Eng mashhur yo'nalishlar",
            items: [
                { href: 'https://tj.wingie.com/uz/flights/to-dushanbe/', title: 'Dushanbe' },
                { href: 'https://tj.wingie.com/uz/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/uz/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/uz/flights/to-moscow/', title: 'Moskva' },
                { href: 'https://tj.wingie.com/uz/flights/to-istanbul/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/uz/flights/to-dubai/', title: 'Dubai' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { href: 'https://tj.wingie.com/uz/flights/ru-rossiya/', title: 'Rossiya' },
                { href: 'https://tj.wingie.com/uz/flights/tr-turkiya/', title: 'Turkiya' },
                { href: 'https://tj.wingie.com/uz/flights/ae-birlashgan-arab-amirliklari/', title: 'Birlashgan Arab Amirliklari' },
                { href: 'https://tj.wingie.com/uz/flights/kz-qozogiston/', title: "Qozog'iston" },
                { href: 'https://tj.wingie.com/uz/flights/uz-ozbekiston/', title: "O'zbekiston" },
                { href: 'https://tj.wingie.com/uz/flights/cn-xitoy/', title: 'Xitoy' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { href: 'https://tj.wingie.com/uz/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/uz/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/uz/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/uz/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/uz/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/uz/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-sr': [
        {
            title: 'Najpopularniji pravci',
            items: [
                { href: 'https://tj.wingie.com/sr/flights/to-dušanbe/', title: 'Dušanbe' },
                { href: 'https://tj.wingie.com/sr/flights/to-hudžend/', title: 'Hudžend' },
                { href: 'https://tj.wingie.com/sr/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/sr/flights/to-moskve/', title: 'Moskva' },
                { href: 'https://tj.wingie.com/sr/flights/to-istanbula/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/sr/flights/to-dubaja/', title: 'Dubai' },
            ],
        },
        {
            title: 'Popularne zemlje',
            items: [
                { href: 'https://tj.wingie.com/sr/flights/ru-rusija/', title: 'Rusija' },
                { href: 'https://tj.wingie.com/sr/flights/tr-turquie/', title: 'Turska' },
                { href: 'https://tj.wingie.com/sr/flights/ae-ujedinjeni-arapski-emirati/', title: 'Ujedinjeni Arapski Emirati' },
                { href: 'https://tj.wingie.com/sr/flights/kz-kazahstan/', title: 'Kazahstan' },
                { href: 'https://tj.wingie.com/sr/flights/uz-uzbekistan/', title: 'Uzbekistan' },
                { href: 'https://tj.wingie.com/sr/flights/cn-kina/', title: 'Kina' },
            ],
        },
        {
            title: 'Popularne avio-kompanije',
            items: [
                { href: 'https://tj.wingie.com/sr/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/sr/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/sr/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/sr/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/sr/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/sr/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-ky': [
        {
            title: 'Эң популярдуу багыттар',
            items: [
                { href: 'https://tj.wingie.com/ky/flights/to-dushanbe/', title: 'Душанбе' },
                { href: 'https://tj.wingie.com/ky/flights/to-khujand/', title: 'Худжанд' },
                { href: 'https://tj.wingie.com/ky/flights/to-kulob/', title: 'Кулоб' },
                { href: 'https://tj.wingie.com/ky/flights/to-moscow/', title: 'Москва' },
                { href: 'https://tj.wingie.com/ky/flights/to-istanbul/', title: 'Стамбул' },
                { href: 'https://tj.wingie.com/ky/flights/to-dubai/', title: 'Дубай' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { href: 'https://tj.wingie.com/ky/flights/ru-russia/', title: 'Орусия' },
                { href: 'https://tj.wingie.com/ky/flights/tr-turkey/', title: 'Түркия' },
                { href: 'https://tj.wingie.com/ky/flights/ae-arab-emirates/', title: 'Араб Эмираттары' },
                { href: 'https://tj.wingie.com/ky/flights/kz-kazakhstan/', title: 'Казакстан' },
                { href: 'https://tj.wingie.com/ky/flights/uz-uzbekistan/', title: 'Өзбекстан' },
                { href: 'https://tj.wingie.com/ky/flights/cn-china/', title: 'Кытай' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { href: 'https://tj.wingie.com/ky/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/ky/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/ky/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/ky/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/ky/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/ky/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-tg': [
        {
            title: 'Самые популярные направления',
            items: [
                { href: 'https://tj.wingie.com/tg/flights/to-dushanbe/', title: 'Душанбе' },
                { href: 'https://tj.wingie.com/tg/flights/to-khujand/', title: 'Худжанд' },
                { href: 'https://tj.wingie.com/tg/flights/to-kulob/', title: 'Кулоб' },
                { href: 'https://tj.wingie.com/tg/flights/to-moscow/', title: 'Москва' },
                { href: 'https://tj.wingie.com/tg/flights/to-istanbul/', title: 'Истанбул' },
                { href: 'https://tj.wingie.com/tg/flights/to-dubai/', title: 'Дубай' },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                { href: 'https://tj.wingie.com/tg/flights/ru-russia/', title: 'Русия' },
                { href: 'https://tj.wingie.com/tg/flights/tr-turkey/', title: 'Туркия' },
                { href: 'https://tj.wingie.com/tg/flights/ae-united-arab-emirates/', title: 'Имороти Араби Муттаҳида' },
                { href: 'https://tj.wingie.com/tg/flights/kz-kazakhstan/', title: 'Қазоқистон' },
                { href: 'https://tj.wingie.com/tg/flights/uz-uzbekistan/', title: 'Ўзбекистон' },
                { href: 'https://tj.wingie.com/tg/flights/cn-china/', title: 'Хитой' },
            ],
        },
        {
            title: 'Ширкатҳои ҳавопаймоии машҳур',
            items: [
                { href: 'https://tj.wingie.com/tg/flights/airlines/somon-air/', title: 'Сомон Эйр' },
                { href: 'https://tj.wingie.com/tg/flights/airlines/tajik-air/', title: 'Тоҷик Эйр' },
                { href: 'https://tj.wingie.com/tg/flights/airlines/ural-airlines/', title: 'Урал Эйрлайнз' },
                { href: 'https://tj.wingie.com/tg/flights/airlines/s7-airlines/', title: 'С7 Эйрлайнз' },
                { href: 'https://tj.wingie.com/tg/flights/airlines/turkish-airlines/', title: 'Туркиш Эйрлайнз' },
                { href: 'https://tj.wingie.com/tg/flights/airlines/fly-dubai/', title: 'флайдубай' },
            ],
        },
    ],
    'tj-kk': [
        {
            title: 'Ең танымал бағыттар',
            items: [
                { href: 'https://tj.wingie.com/kk/flights/to-dushanbe/', title: 'Душанбе' },
                { href: 'https://tj.wingie.com/kk/flights/to-khujand/', title: 'Худжанд' },
                { href: 'https://tj.wingie.com/kk/flights/to-kulob/', title: 'Кулоб' },
                { href: 'https://tj.wingie.com/kk/flights/to-moscow/', title: 'Мәскеу' },
                { href: 'https://tj.wingie.com/kk/flights/to-istanbul/', title: 'Стамбул' },
                { href: 'https://tj.wingie.com/kk/flights/to-dubai/', title: 'Дубай' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { href: 'https://tj.wingie.com/kk/flights/ru-russia/', title: 'Ресей' },
                { href: 'https://tj.wingie.com/kk/flights/tr-turkey/', title: 'Түркия' },
                { href: 'https://tj.wingie.com/kk/flights/ae-united-arab-emirates/', title: 'Араб Эмираттары' },
                { href: 'https://tj.wingie.com/kk/flights/kz-kazakhstan/', title: 'Қазақстан' },
                { href: 'https://tj.wingie.com/kk/flights/uz-uzbekistan/', title: 'Өзбекстан' },
                { href: 'https://tj.wingie.com/kk/flights/cn-china/', title: 'Қытай' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { href: 'https://tj.wingie.com/kk/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/kk/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/kk/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/kk/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/kk/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/kk/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-nl': [
        {
            title: 'Populaire bestemmingen',
            items: [
                { href: 'https://tj.wingie.com/nl/flights/to-dushanbe/', title: 'Dushanbe' },
                { href: 'https://tj.wingie.com/nl/flights/to-khujand/', title: 'Khujand' },
                { href: 'https://tj.wingie.com/nl/flights/to-kulob/', title: 'Kulob' },
                { href: 'https://tj.wingie.com/nl/flights/to-moskou/', title: 'Moskou' },
                { href: 'https://tj.wingie.com/nl/flights/to-istanbul/', title: 'Istanbul' },
                { href: 'https://tj.wingie.com/nl/flights/to-dubai/', title: 'Dubai' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { href: 'https://tj.wingie.com/nl/flights/ru-rusland/', title: 'Rusland' },
                { href: 'https://tj.wingie.com/nl/flights/tr-turkije/', title: 'Turkije' },
                { href: 'https://tj.wingie.com/nl/flights/ae-verenigde-arabische-emiraten/', title: 'Verenigde Arabische Emiraten' },
                { href: 'https://tj.wingie.com/nl/flights/kz-kazachstan/', title: 'Kazachstan' },
                { href: 'https://tj.wingie.com/nl/flights/uz-oezbekistan/', title: 'Oezbekistan' },
                { href: 'https://tj.wingie.com/nl/flights/cn-china/', title: 'China' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { href: 'https://tj.wingie.com/nl/flights/airlines/somon-air/', title: 'Somon Air' },
                { href: 'https://tj.wingie.com/nl/flights/airlines/tajik-air/', title: 'Tajik Air' },
                { href: 'https://tj.wingie.com/nl/flights/airlines/ural-airlines/', title: 'Ural Airlines' },
                { href: 'https://tj.wingie.com/nl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://tj.wingie.com/nl/flights/airlines/turkish-airlines/', title: 'Turkish Airlines' },
                { href: 'https://tj.wingie.com/nl/flights/airlines/fly-dubai/', title: 'flydubai' },
            ],
        },
    ],
    'tj-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://tj.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://tj.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://tj.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://tj.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://tj.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://tj.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://tj.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://tj.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://tj.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://tj.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://tj.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://tj.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://tj.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://tj.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://tj.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://tj.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://tj.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://tj.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://tj.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://tj.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://tj.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://tj.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://tj.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://tj.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://tj.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://tj.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://tj.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://tj.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://tj.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://tj.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://tj.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://tj.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://tj.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://tj.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://tj.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://tj.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://tj.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://tj.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://tj.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://tj.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://tj.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://tj.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://tj.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://tj.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://tj.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://tj.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://tj.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://tj.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://tj.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://tj.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://tj.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://tj.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://tj.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://tj.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://tj.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://tj.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://tj.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://tj.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://tj.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://tj.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://tj.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://tj.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://tj.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://tj.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://tj.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://tj.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://tj.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://tj.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://tj.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://tj.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://tj.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://tj.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://tj.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://tj.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://tj.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://tj.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://tj.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://tj.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://tj.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://tj.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://tj.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://tj.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://tj.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://tj.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://tj.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://tj.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://tj.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://tj.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://tj.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://tj.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://tj.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://tj.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://tj.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://tj.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://tj.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://tj.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://tj.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://tj.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://tj.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://tj.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://tj.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://tj.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://tj.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://tj.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://tj.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://tj.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://tj.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://tj.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://tj.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://tj.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://tj.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://tj.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://tj.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://tj.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://tj.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://tj.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://tj.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://tj.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://tj.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'tj-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://tj.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://tj.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://tj.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://tj.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://tj.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://tj.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://tj.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://tj.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://tj.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://tj.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://tj.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://tj.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://tj.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://tj.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://tj.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://tj.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://tj.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://tj.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}